import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import baseURL from '../../url';
import './Profecionales.css';

export default function NewProfesional({ profesional = {}, cerrarModal, recargar }) {
    const [loading, setLoading] = useState(false);
    const [nombre, setNombre] = useState(profesional.nombre || '');
    const [categoriasDisponibles, setCategoriasDisponibles] = useState([]);
    
    // Estado para los IDs de las categorías seleccionadas
    const [selectedCats, setSelectedCats] = useState([]);

    useEffect(() => {
        cargarDatos();
        // Si estamos editando, parseamos las categorías que ya tiene el profesional
        if (profesional.categorias) {
            try {
                const cats = JSON.parse(profesional.categorias);
                setSelectedCats(Array.isArray(cats) ? cats.map(String) : []);
            } catch (e) {
                console.error("Error al parsear categorías del profesional", e);
                setSelectedCats([]);
            }
        }
    }, [profesional]);

    const cargarDatos = async () => {
        try {
            const resCat = await fetch(`${baseURL}/categoriasGet.php`);
            const dataCat = await resCat.json();
            setCategoriasDisponibles(dataCat.categorias || []);
        } catch (err) {
            console.error("Error cargando categorías:", err);
        }
    };

    // Maneja el tildar/destildar de cada categoría
    const handleToggleCategory = (id) => {
        const idStr = id.toString();
        if (selectedCats.includes(idStr)) {
            setSelectedCats(selectedCats.filter(c => c !== idStr));
        } else {
            setSelectedCats([...selectedCats, idStr]);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const formData = new FormData();
        if (profesional.id) formData.append('id', profesional.id);
        formData.append('nombre', nombre);
        // Enviamos el array de IDs como un string JSON
        formData.append('categorias', JSON.stringify(selectedCats));

        try {
            const res = await fetch(`${baseURL}/profesionalesPost.php`, {
                method: 'POST',
                body: formData,
            });
            const data = await res.json();
            if (data.error) {
                Swal.fire('Error', data.error, 'error');
            } else {
                Swal.fire('Éxito', data.mensaje, 'success');
                cerrarModal();
                recargar();
            }
        } catch (err) {
            Swal.fire('Error', err.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal">
            <div className="modal-content">
                <span className="close" onClick={cerrarModal}>&times;</span>
                <h3>{profesional.id ? 'Editar profesional' : 'Nuevo profesional'}</h3>
                
                <form onSubmit={handleSubmit} className="form-profesional">
                    <div className="form-group">
                        <label>Nombre</label>
                          <input 
                            type="text" 
                            value={nombre} 
                            onChange={e => setNombre(e.target.value)} 
                            required 
                            placeholder="Nombre del profesional"
                        />
                    </div>

                    <div className="form-group">
                        <label>Categorías / Especialidades</label>
                        <div className="categorias-selector-pills">
                            {categoriasDisponibles.map(cat => {
                                const isSelected = selectedCats.includes(cat.idCategoria.toString());
                                return (
                                    <button
                                        type="button"
                                        key={cat.idCategoria}
                                        className={`categoria-pill ${isSelected ? 'active' : ''}`}
                                        onClick={() => handleToggleCategory(cat.idCategoria)}
                                    >
                                        {cat.categoria} {isSelected ? ' ✓' : ''}
                                    </button>
                                );
                            })}
                        </div>
                        {categoriasDisponibles.length === 0 && (
                            <p className="p-aviso">No hay categorías disponibles.</p>
                        )}
                    </div>

                    <button type="submit" className="btn btn-add" disabled={loading}>
                        {loading ? 'Cargando...' : (profesional.id ? 'Actualizar' : 'Crear')}
                    </button>
                </form>
            </div>
        </div>
    );
}
